import { render, staticRenderFns } from "./BulkUploadCommentaryApproverDialog.vue?vue&type=template&id=6283d074"
import script from "./BulkUploadCommentaryApproverDialog.vue?vue&type=script&lang=js"
export * from "./BulkUploadCommentaryApproverDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports